import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENTID,
        authority: process.env.REACT_APP_TENANTID, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        redirectUri: window.location.origin,
        postLogoutRedirectUri: "https://www.karnovgroup.no/",
    },

    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Required for Safari and browsers with strict cookie policies
    },
};

// Single app-wide MSAL instance, constructed lazily on first use (rather than at module
// import time) so that merely importing this module - e.g. transitively through ApiCalls.js
// in unit tests - doesn't construct a PublicClientApplication in environments (jsdom/node)
// that lack the browser crypto APIs MSAL requires.
let msalInstanceSingleton = null;

export function getMsalInstance() {
    if (!msalInstanceSingleton) {
        msalInstanceSingleton = new PublicClientApplication(msalConfig);
    }
    return msalInstanceSingleton;
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: [
        process.env.REACT_APP_LOGIN_SCOPES,
    ],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com",
};
